module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('input', {
    staticClass: "m-0 p-0",
    attrs: {
      "type": "text",
      "placeholder": "Search for ..."
    },
    on: {
      "keyup": _vm.typing
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "ico-search larger color-1"
  })]), _vm._v(" "), _c('advanced', {
    attrs: {
      "table": _vm.table,
      "rows": _vm.rows
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e486ee2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Search.vue
// module id = 2525
// module chunks = 0